export default function CtaSection() {
  return (
    <section className="w-full py-14 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 mb-4">
          Comece a Comprar da China Hoje
        </h2>
        <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto mb-8 leading-relaxed">
          Acesse o CSSBuy Spreadsheet agora e descubra como importar produtos com
          segurança, economia e organização.
        </p>
        <a
          href="https://kaspreadsheet.com/"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-10 py-4 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-base font-semibold transition-all cursor-pointer whitespace-nowrap"
        >
          CSSBuy Spreadsheet
          <i className="ri-arrow-right-line text-lg"></i>
        </a>
      </div>

      <div className="max-w-7xl mx-auto mt-14">
        <div className="flex flex-wrap justify-center gap-4">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20chunky%20sneakers%20in%20warm%20taupe%20tones%20on%20a%20light%20travertine%20surface%2C%20soft%20directional%20shadow%2C%20editorial%20product%20photography%2C%20minimalist%20fashion%20aesthetic%2C%20warm%20natural%20lighting&width=220&height=160&seq=cta-strip-01-v5&orientation=landscape"
            alt=""
            className="w-[180px] h-[130px] md:w-[220px] md:h-[160px] object-cover rounded-xl"
            loading="lazy"
          />
          <img
            src="https://readdy.ai/api/search-image?query=Cozy%20knit%20sweater%20in%20soft%20oatmeal%20color%20elegantly%20folded%20on%20a%20warm%20oak%20surface%2C%20gentle%20window%20light%2C%20editorial%20fashion%20photography%2C%20minimalist%20aesthetic%2C%20cream%20and%20beige%20palette&width=220&height=160&seq=cta-strip-02-v5&orientation=landscape"
            alt=""
            className="w-[180px] h-[130px] md:w-[220px] md:h-[160px] object-cover rounded-xl hidden md:block"
            loading="lazy"
          />
          <img
            src="https://readdy.ai/api/search-image?query=Structured%20leather%20crossbody%20bag%20in%20rich%20caramel%20color%20on%20a%20warm%20sandstone%20surface%2C%20soft%20golden%20light%2C%20luxury%20accessories%20editorial%20photography%2C%20sophisticated%20minimalist%20aesthetic&width=220&height=160&seq=cta-strip-03-v5&orientation=landscape"
            alt=""
            className="w-[180px] h-[130px] md:w-[220px] md:h-[160px] object-cover rounded-xl"
            loading="lazy"
          />
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20watch%20with%20leather%20strap%20on%20a%20warm%20marble%20surface%2C%20soft%20diffused%20light%2C%20luxury%20accessories%20editorial%20photography%2C%20sophisticated%20neutral%20palette%2C%20refined%20aesthetic&width=220&height=160&seq=cta-strip-04-v5&orientation=landscape"
            alt=""
            className="w-[180px] h-[130px] md:w-[220px] md:h-[160px] object-cover rounded-xl hidden lg:block"
            loading="lazy"
          />
          <img
            src="https://readdy.ai/api/search-image?query=Premium%20heavyweight%20t-shirt%20in%20sage%20green%20draped%20over%20a%20wooden%20hanger%2C%20soft%20natural%20light%2C%20editorial%20fashion%20product%20photography%2C%20minimalist%20aesthetic%2C%20warm%20earthy%20tones&width=220&height=160&seq=cta-strip-05-v5&orientation=landscape"
            alt=""
            className="w-[180px] h-[130px] md:w-[220px] md:h-[160px] object-cover rounded-xl hidden lg:block"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}